import { useEffect, useRef } from 'react'

export const useOutsideClickListener = (onOutsideClick: (target: HTMLElement) => void) => {
  const ref = useRef(null)

  const handleClickOutside = (event: Event) => {
    if (
      ref.current &&
      event.target instanceof HTMLElement &&
      !ref.current.contains(event.target) &&
      !event.composedPath?.()?.includes(ref.current)
    ) {
      onOutsideClick(event.target)
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('click', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('click', handleClickOutside)
    }
  }, [onOutsideClick])

  return ref
}
